import { render, staticRenderFns } from "./UniversityMenu.vue?vue&type=template&id=7407f198&"
import script from "./UniversityMenu.vue?vue&type=script&lang=js&"
export * from "./UniversityMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports